/**
 * Plain ol javascript methods to validate. Trying to divorce the logic from
 * the mixins to help eventually move to vue 3
 */

const PAYROLL_ALLOWED_WORDS = ['If Any']
const LIMIT_ALLOWED_WORDS = ['Included', 'ALS', 'Liability Only']

const ALLOWED_WORDS_MAP = {
  PAYROLL_ALLOWED_WORDS: PAYROLL_ALLOWED_WORDS,
  LIMIT_ALLOWED_WORDS: LIMIT_ALLOWED_WORDS,
}

export function validateStateCode(content) {
  // not a required check
  if (content === null || content === undefined || content === '') return
  if (!/^[A-Za-z]{2}$/.test(content)) return 'Invalid State Code'
}

export function validateRequired(content) {
  if (content === null || content === undefined || content === '') return 'This is required'
}
export function taxIdShape(content) {
  if (content === null || content === undefined || content === '') return
  const businessTaxId = /^\d{2}-\d{7}$/
  if (businessTaxId.test(content)) {
    return // is a business tax id
  } else {
    return 'xx-xxxxxxx'
  }
}

export function yearOrDate(content) {
  if (content === null || content === undefined || content === '') return
  const year = /^\d{4}$/
  const date = /^\d\d\d\d-\d\d-\d\d$/ //2020-12-02
  if (year.test(content)) {
    return // this is a year
  } else if (date.test(content)) {
    return // This is a date
  } else {
    return 'must be a year (2024) or date (ie: 2024-09-02)'
  }
}
function isWholeNumber(input) {
  const whole_number = /^[\d ]*$/g
  return !(input && !whole_number.test(input))
}
function isNumber(input) {
  const number = /^(\d)+(\.\d+)?$/g
  return !(input && !number.test(input))
}
export function wholeNumbersOnly(content) {
  if (content === null || content === undefined || content === '') return
  if (!isWholeNumber(content) === true) {
    return 'must be a whole number'
  }
}

// Used by Property InsuranceLimit (And perhaps others)
export function wholeNumberOrAllowedWords(content, allowedWords = []) {
  if (content === null || content === undefined || content === '') return

  if (typeof allowedWords === 'string') {
    allowedWords = ALLOWED_WORDS_MAP[allowedWords] || [allowedWords]
  }

  const normalizedContent = content.toString().trim().toLowerCase()
  const isAllowedWord = allowedWords.some(word => word.toLowerCase() === normalizedContent)

  if (!isWholeNumber(content) && !isAllowedWord) {
    const allowedWordsString = allowedWords.map(word => `'${word}'`).join(' or ')
    return `must be a whole number or ${allowedWordsString}`
  }
}
export function numberOrAllowedWords(content, allowedWords = []) {
  if (content === null || content === undefined || content === '') return
  if (typeof allowedWords === 'string') {
    allowedWords = ALLOWED_WORDS_MAP[allowedWords] || [allowedWords]
  }

  const normalizedContent = content.toString().trim().toLowerCase()
  const isAllowedWord = allowedWords.some(word => word.toLowerCase() === normalizedContent)

  if (!isNumber(content) && !isAllowedWord) {
    const allowedWordsString = allowedWords.map(word => `'${word}'`).join(' or ')
    return `must be a number or ${allowedWordsString}`
  }
}

export function isDateStringYYYYMMDDExpectedFormat(input, format) {
  const date_string = /^\d{4}-\d{2}-\d{2}$/g
  if (!input) {
    // This does not make it required
    return false
  }

  if (input && !date_string.test(input)) {
    return `must be a date ${format}`
  }

  const dateParts = input.split('-')
  const year = Number(dateParts[0])
  const month = Number(dateParts[1])
  const date = Number(dateParts[2])
  if (year < 1800) {
    return 'year is too low'
  }
  if (month < 0 || month > 12) {
    return 'Invalid month. (yyyy-mm-dd)'
  }
  if (date < 0 || date > 31) {
    return 'Invalid day. (yyyy-mm-dd)'
  }
}

// tightly coupled with vue-excel-column
export function validateLeasedOrOwned(content, oldContent, record) {
  if (content === null || content === undefined || content === '') return
  content = content.trim()
  if ('L' === content.toUpperCase() || 'LEASE' === content.toUpperCase()) {
    content = 'LEASED'
  }
  if ('O' === content.toUpperCase() || 'OWN' === content.toUpperCase()) {
    content = 'OWNED'
  }
  if (['LEASED', 'OWNED'].indexOf(content.toUpperCase()) === -1) return 'Must be LEASED or OWNED'
  record.leaseOrOwned = content.toUpperCase()
}

export function mustBeJsonString(content) {
  if (content === null || content === undefined || content === '') return true
  if (!isJsonString(content)) return 'Must be valid json'
  return true
}
export function isJsonString(str) {
  try {
    const json = JSON.parse(str)
    return typeof json === 'object'
  } catch (e) {
    return false
  }
}
